export const tableCellStyleAdmin = {
  paddingX: {
    xxl: '1rem',
    xl: '0.8rem',
    lg: '0.6rem',
    md: '0.5rem',
  },
  fontSize: {
    xxl: '1rem',
    xl: '0.8rem',
    lg: '0.6rem',
    md: '0.5rem',
  },
  color: '#6B778C',
  cursor: 'default',
  lineHeight: '0.1rem',
};

export const tableRowCellAdmin = {
  borderBottom: 'none',
  padding: '0.5rem',
  paddingX: {
    xxl: '1rem',
    xl: '0.8rem',
    lg: '0.7rem',
    md: '0.6rem',
  },
  color: '#172B4D',
  fontSize: {
    xxl: '1rem',
    xl: '0.8rem',
    lg: '0.7rem',
    md: '0.6rem',
  },

  lineHeight: '0.1rem',
};

export const commonTableCellStyle = {
  padding: '0.5rem',
  paddingX: {
    xxl: '1rem',
    xl: '0.8rem',
    lg: '0.6rem',
    md: '0.5rem',
  },
  fontSize: {
    xxl: '1rem',
    xl: '0.8rem',
    lg: '0.6rem',
    md: '0.5rem',
  },
  color: '#6B778C',
  cursor: 'default',
};

export const commonTableRowCellStyle = {
  borderBottom: 'none',
  padding: '0.5rem',
  paddingX: {
    xxl: '1rem',
    xl: '0.8rem',
    lg: '0.7rem',
    md: '0.6rem',
  },
  fontSize: {
    xxl: '1rem',
    xl: '0.8rem',
    lg: '0.7rem',
    md: '0.6rem',
  },
  color: '#172B4D',
};

export const tableCellStyle = {
  padding: 1,
  fontSize: { xl: '1rem', md: '0.6rem' },
  color: '#6B778C',
  cursor: 'default',
};
export const tableRowCellStyle = {
  borderBottom: 'none',
  padding: 1,
  color: '#172B4D',
  fontSize: { xl: '1rem', md: '0.7rem' },
};

export const tableCellStyleRestrictions = {
  padding: { xxl: '0.75rem 0.75rem', xl: '0.375rem 0.375rem' },
  fontSize: { xxl: '1rem', xl: '0.9rem' },
  color: '#6B778C',
  cursor: 'default',
  textAlign: 'left',
};

export const tableRowCellStyleRestrictions = {
  borderBottom: 'none',
  padding: { xxl: '0.75rem 0.75rem', xl: '0.5rem 0.5rem' },
  color: '#172B4D',
  fontSize: { xxl: '1rem', xl: '0.9rem' },
  textAlign: 'left',
  minWidth: '10.625rem',
};

export const insightsTableCell = {
  fontSize: '1rem',
  color: '#6B778C',
  cursor: 'default',
};

export const insightsTableRowCell = {
  borderBottom: 'none',
  color: '#172B4D',
  fontSize: '1rem',
  cursor: 'default',
};

export const tableCellStyleAuditing = {
  borderBottom: '0.125rem solid lightgray',
  padding: {
    xxl: 1.0,
    xl: 0.1,
    lg: '0rem !important',
  },
  fontSize: {
    xxl: '0.8rem',
    xl: '0.7rem',
    md: '0.6rem',
    lg: '0.5rem',
  },
  color: '#6B778C',
  cursor: 'default',
  textAlign: 'center',
};

export const tableRowCellStyleAuditing = {
  borderBottom: 'none',
  padding: {
    xxl: '0.7 !important',
    xl: 0.1,
    lg: '0rem !important',
  },
  marginLeft: '0.938rem',
  color: '#172B4D',
  fontSize: {
    xxl: '0.9rem',
    xl: '0.65rem',
    md: '0.7rem',
    lg: '0.6rem',
  },
  cursor: 'pointer',
};

export const hoverRowStyles = {
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
};
